module.exports = __webpack_public_path__ + "img/fernanda.4afc1927.png";